import * as React from 'react';

import type {
    GetPlanComparisons_planComparisons_featureGroups_features_planAvailabilities_value as AvailabilityValue,
    GetPlanComparisons_planComparisons_featureGroups_features_planAvailabilities as PlanAvailability,
} from 'nutshell-graphql-types';

import {colors} from '../../colors/colors';
// @ts-expect-error - imported from .js/.jsx file
import {CheckmarkIcon} from '../../icon/svg/checkmark-icon';
import {Body} from '../../typography/body';

type Props = {
    planAvailability: PlanAvailability;
};

function getCellContents(valueType: string, customValue?: string | null) {
    switch (valueType) {
        case 'Unlimited':
            return <Body size='normal'>Unlimited</Body>;
        case 'Checkmark':
            return (
                <CheckmarkIcon
                    size={15}
                    className='flex align-center justify-center'
                    color={colors.green}
                />
            );
        case 'CustomString':
            return <Body size='normal'>{customValue}</Body>;
        case 'Xmark':
            return <></>;
        default:
            return <></>;
    }
}

export function PlanComparisonTableCell(props: Props) {
    const availabilityValue: AvailabilityValue = props.planAvailability.value;

    return getCellContents(availabilityValue.availabilityValueType, availabilityValue.customValue);
}
